import React from 'react'

// Component
import { Button, Section } from '../../../components'

const ButtonBack = ({ props, apiRedirectPath }) => {
  return (
    <Section className="button-top-page">
      <Button
        className="theme-border"
        onClick={() => {
          props.history.push(apiRedirectPath)
        }}
      >
        &lt; &nbsp; Back
      </Button>
    </Section>
  )
}

export default ButtonBack
